<template>
  <div class="quote__list-insured">
    <div class="quote__accordion">
      <BaseAccordion>
        <template v-slot:name>
          {{ $t('renew.checkout.boat_info.title.placeholder') }}
        </template>
        <template v-slot:content>
          <ul class="quote__policy-list">
            <li v-for="itemInfo of boatInfo" :key="itemInfo.title">
              <div class="quote__policy-name">{{itemInfo.title}}</div>
              <div class="quote__policy-value">{{ itemInfo.content }}</div>
            </li>
          </ul>
        </template>
      </BaseAccordion>
    </div>
  </div>
</template>

<script>
import { BaseAccordion } from 'qic-components'
export default {
  name: 'QuoteBoatInfo',
  props: {
    info: {
      type: Object,
      default: () => ({
        seatingCapacity: '',
        yearOfBuilt: '',
        regNumber: '',
        portOfRegistry: '',
        engine: '',
        numberEngines: ''
      })
    }
  },
  components: {
    BaseAccordion
  },
  computed: {
    boatInfo () {
      return [
        {
          title: this.$t('renew.checkout.boat_info.passenger_cap.title'),
          content: this.info.seatingCapacity
        },
        {
          title: this.$t('renew.checkout.boat_info.built_year.title'),
          content: this.info.yearOfBuilt
        },
        {
          title: this.$t('renew.checkout.boat_info.reg_number.title'),
          content: this.info.regNumber
        },
        {
          title: this.$t('renew.checkout.boat_info.reg_port.title'),
          content: this.info.portOfRegistry
        },
        {
          title: this.$t('renew.checkout.boat_info.engine.title'),
          content: this.info.engine
        },
        {
          title: this.$t('renew.checkout.boat_info.number_engines.title'),
          content: this.info.numberEngines
        }
      ].filter(value => value.content)
    }
  }
}
</script>
